import React from 'react';
import trans from 'counterpart';
import { postBookingUrl } from '../../api/bookingApi';

class YourzineShoppingBasketBlock extends React.Component {
  state = {
    email: '',
    success: null,
    error: null
  }

  handleSubmit = () => {
    const { email } = this.state;
    this.setState({ error: null });
    if (email.match('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$')) {
      return postBookingUrl(email, window.location.href)
        .then(success => this.setState({ success }))
        .catch(() => this.setState({ error: 'save_booking_failure' }));
    }

    this.setState({ error: 'email_invalid' });
    return Promise.resolve();
  }

  render() {
    const { email, error, success } = this.state;
    return (
      <div className="save-booking">
        <div className="h5 text-info text-lato mb-1">
          {trans('label.save_booking_title')}
        </div>
        <div className="body">
          {trans('label.save_booking_body')}
        </div>
        <input
          type="email"
          className="form-control input"
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
          value={email}
          onChange={e => this.setState({ email: e.target.value })}
        />
        <button
          type="button"
          onClick={this.handleSubmit}
          className={`"btn btn-green" ${success === null ? 'btn btn-green more' : 'btn btn-green less'}`}
        >
          {trans('label.save_booking_button')}
        </button>
        {success && (
          <div className="feedback">
            {trans('label.save_booking_success')}
          </div>
        )}
        {error !== null && (
          <div className="feedback">
            {trans(`error.${error}`)}
          </div>
        )}
      </div>
    );
  }
}

export default YourzineShoppingBasketBlock;
